import { DividerSection as DividerSectionType } from '../../LandingPage.types'
import css from './DividerSection.styles.scss'

interface DividerSectionProps {
  section: DividerSectionType
}

const DividerSection = ({ section: { variant } }: DividerSectionProps) => (
  <div className={css.DividerSection__container}>
    {variant === 'squiggle' && (
      <img
        alt="divider"
        src="https://images.babylist.com/image/upload/v1683911055/Dynamic%20Landing%20Pages/Squiggle_divider.svg"
      />
    )}
  </div>
)

export default DividerSection
